import dynamic from 'next/dynamic';

const CommentsBottomSheet = dynamic(
  () => import('./comments').then((mod) => mod.CommentsBottomSheet),
  {
    ssr: false,
  }
);

export const CommentsBottomSheetWrapper = (props: any) => {
  return (
    <>
      <CommentsBottomSheet {...props} />
    </>
  );
};
